import React, {useState, useEffect } from 'react';
import {Button, Grid, TextField, Divider, MenuItem, Tooltip} from '@material-ui/core';
import {useSelector, useDispatch} from 'react-redux';
import {singleBlueprintbackup} from '../../../store/blueprint/actions';
import {handleSnackBar, invokeGetService} from '../../../store/global/actions';
import Alert from '@material-ui/lab/Alert';
import { validationMessages, requiredOnly, requiredOnlyMessage} from '../../../config/validations';
import {getBlueprintDetails} from '../../../store/global/selectors';
import { getLoggedUsername} from '../../../store/auth/selectors';
import { useForm} from 'react-hook-form';

export default function CreateBlueprintBackup({onCompletion, backupLocations, gitConfiguration, clearAlert, setClearAlert}) {
  const {register,handleSubmit,formState: {errors},reset,setValue} = useForm();
  const dispatch = useDispatch();
  const [alert, setAlert] = useState(null);
  const [backupInProgress, setbackupInProgress] = useState(false);
  const [error, setError] = useState(null);
  const [backupLocation, setBackupLocation] = useState( gitConfiguration ? "git_repo" : "S3" );

  const details = useSelector(getBlueprintDetails);
  const loggedInUsername = useSelector(getLoggedUsername);

  const disableBackup = localStorage.getItem("backupInProgress") !== undefined && localStorage.getItem("backupInProgress") !== null ? true : false; 

  const alertStyle = { marginBottom: 10, marginTop: 10 }

  const onMessageCallback = ({data, backupItem}) => {
    
    data = JSON.parse(data);
    if(data?.message === "Backup Started"){
      let obj = {message: backupItem?.message, blueprintId: backupItem?.blueprintId}
      localStorage.setItem("backupInProgress", JSON.stringify(obj))
      
      dispatch(handleSnackBar({open: true, message: 'Preparing backup', severity: 'info'}));
      setbackupInProgress(true);
    }
    
    if (data?.message === "Backup completed" || data?.message === "No changes from the last backup"){
      if(localStorage.getItem("backupInProgress") !== null && localStorage.getItem("backupInProgress") !== undefined){
        localStorage.removeItem("backupInProgress");
      }
      onCompletion({...dispatch(handleSnackBar({open: true, message: data?.message, severity: data?.message === "Backup completed" ?'success' : "info"}))});
      setClearAlert(false);
      setAlert('success');
      reset({name: ''});
      setbackupInProgress(false);
    }

    if(data?.status == false){
      if(localStorage.getItem("backupInProgress") !== null && localStorage.getItem("backupInProgress") !== undefined){
        localStorage.removeItem("backupInProgress");
      }
      onCompletion({...dispatch(handleSnackBar({open: true, message: data?.message, severity: 'error'}))});
      setClearAlert(false);
      setAlert('success');
      reset({name: ''});
      setbackupInProgress(false);
    }

    
  }

  const onErrorCallback = (error) => { 
    console.log("--onErrorCallback--")
    console.log({error}) 

    if(localStorage.getItem("backupInProgress") !== null && localStorage.getItem("backupInProgress") !== undefined){
      localStorage.removeItem("backupInProgress");
    }
    
    // onCompletion({...dispatch(handleSnackBar({open: true, message: 'Create backup failed', severity: 'error'}))});
    reset({name: ''});
    setbackupInProgress(false);
  }

  const onCloseCallback = (data) => {
    setbackupInProgress(false);
  }

  const onCreateBackup = (data) => {
    setbackupInProgress(true);
    dispatch(singleBlueprintbackup(data, backupLocation, onMessageCallback, onErrorCallback))
  };

  const messages = {
    ...validationMessages,
    ...requiredOnlyMessage,
    validate: 'This name is already used',
  };

  const generateBackupMessage = () => {
    const blueprintName = details?.slug;
    const username = convertStrToSlug(loggedInUsername.split('@')[0]);
    

    const backupName = `${blueprintName}_${username}_${generateDateTime()}`;

    return backupName;
  };

  const convertStrToSlug = text => {
    let mytext = text.toLowerCase().replace(/ /g, '-').replace(/[^\w-]+/g, '');
    return mytext;
  }

  const generateDateTime = () => {
    const currentDate = new Date(); 

    const day = addZeroPrefix(currentDate.getDate());
    const month = addZeroPrefix(currentDate.getMonth() + 1);
    const year = currentDate.getFullYear();
    const hour = addZeroPrefix(currentDate.getHours());
    const minute = addZeroPrefix(currentDate.getMinutes());
    const second = addZeroPrefix(currentDate.getSeconds());

    return `${day}${month}${year}_${hour}${minute}${second}`
  }

  
  const addZeroPrefix = number => number < 10 ? '0' + number : number;
  
  const handleBackupLocationChange = (e) => {
    const value = e.target.value;
  
    if (gitConfiguration === null) {
      setBackupLocation("S3");
      return; // hard stop – do NOT allow selection
    }
  
    setBackupLocation(value);
  };

  useEffect(() => {

    if (details && loggedInUsername) {
      setValue('name', generateBackupMessage());
    }
  }, [details, loggedInUsername]);


  return (
    <Grid container direction={'row'} spacing={2} data-ui-tour-id="create-backup-area">
      <Grid item xs={12}>
        {error && <Alert variant="filled" style={alertStyle} severity="error">{error}</Alert>}
      </Grid>
      <Grid item xs={6}>
        <TextField name="name" id={"backup_message_field"} autoFocus fullWidth size={'small'} type={'text'} required={true} label={'Message'} placeholder={''} variant="outlined" inputRef={register({...requiredOnly})} error={errors?.name ? true : false} helperText={errors?.name ? messages[errors?.name?.type] : ''} />
      </Grid>
      
      {/* Backup location drop-down */}
      <Grid item xs={2} style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <TextField
          id={"backup_location"}
          select
          fullWidth
          size="small"
          variant="outlined"
          label="Backup Location"
          value={backupLocation}
          onChange={handleBackupLocationChange}
        >
          {backupLocations.map((option) => {
            const isGit = option.value === 'git_repo';
            const isGitDisabled = isGit && gitConfiguration === null;

            return isGitDisabled ? (
              <Tooltip
                key={option.value}
                title="You do not have a Git repository configured."
                placement="right"
                arrow
              >
                <span>
                  <MenuItem value={option.value} disabled>
                    {option.label}
                  </MenuItem>
                </span>
              </Tooltip>
            ) : (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            );
          })}
        </TextField>
      </Grid>

      <Grid item xs={4} style={{display: 'flex', justifyContent: 'flex-end'}}>
        <Button id={"create_backup_now"} onClick={handleSubmit(onCreateBackup)} disabled={disableBackup || backupInProgress} color="primary" variant="contained" style={{minWidth:  '200px', marginTop: 0, height: 38, textTransform: 'capitalize'}}>Backup Now</Button>
      </Grid>
      <Grid item xs={12}><Divider /></Grid>
    </Grid>
  );
}
